import React from 'react';
import { Faq as Q, P, Sub, UI } from '../ui';
import { useUploadPolicy } from '../../../services/uploadPolicyService';

export const Faq: React.FC = () => {
  // 첨부 제한은 관리자 콘솔에서 바뀔 수 있다 (도움말 '파일과 이미지'와 같은 출처)
  const { maxFileSizeMB, maxFiles, retentionDays } = useUploadPolicy();

  return (
  <>
    <Sub>앱 사용</Sub>

    <Q q="앱을 껐는데 계속 실행되고 있어요.">
      <p>
        정상 동작입니다. 창의 <UI>×</UI>를 누르면 종료되지 않고 트레이로 숨습니다. 알림을 계속 받기 위해서입니다.
      </p>
      <p>
        완전히 끄려면 화면 오른쪽 아래 시계 옆의 INA-TALK 트레이 아이콘을 <b>마우스 오른쪽 버튼으로 클릭</b>한 뒤{' '}
        <UI>종료</UI>를 선택하세요.
      </p>
    </Q>

    <Q q="알림이 전혀 오지 않습니다.">
      <p>세 곳을 순서대로 확인하세요.</p>
      <p>
        ① 트레이 아이콘 우클릭 → <UI>알림 받기</UI>에 체크가 되어 있는지 (여기가 꺼져 있으면 앱 안의 설정으로는
        되살릴 수 없습니다)
        <br />② 해당 대화방을 우클릭해 음소거 상태가 아닌지
        <br />③ Windows 알림 설정과 집중 지원(방해 금지)이 켜져 있지 않은지
      </p>
    </Q>

    <Q q="특정 대화방만 알림이 안 와요.">
      <p>
        그 방이 음소거 상태입니다. 대화방 목록에서 이름 옆에 종에 빗금 친 아이콘이 있는지 확인하고, 우클릭 →{' '}
        <UI>알림 켜기</UI>를 선택하세요.
      </p>
    </Q>

    <Q q="알림은 안 오는데 빨간 숫자만 계속 늘어납니다.">
      <p>
        음소거된 대화방의 정상 동작입니다. 알림 끄기는 팝업만 막고 안 읽은 개수는 그대로 세도록 설계되어 있습니다.
        중요한 방이라면 알림을 다시 켜세요.
      </p>
    </Q>

    <Sub>메시지</Sub>

    <Q q="보낸 메시지를 수정하고 싶어요.">
      <p>
        메시지를 우클릭해 <b>수정</b>을 누르면 (모바일은 길게 눌러 <UI>수정</UI>) 고칠 수 있습니다.
        수정하면 시각 옆에 <UI>(수정됨)</UI> 표시가 붙습니다. 파일이 첨부된 메시지는 수정할 수 없으니 삭제 후 다시
        보내주세요.
      </p>
    </Q>

    <Q q="예약한 메시지가 전송되지 않았어요.">
      <p>
        예약 시각에 보낼 수 없는 상태였기 때문입니다. 예약해 둔 대화방에서 나갔거나 대화방이 삭제된
        경우, 첨부한 파일을 찾을 수 없는 경우 메시지는 전송되지 않고, 입력창 위 <UI>예약 메시지</UI> 칩을
        눌러 열리는 <UI>예약 목록</UI>에 <b>보내지 못한 사유</b>가 표시됩니다. 내용을 확인한 뒤 필요하면 다시
        예약해 주세요.
      </p>
      <p>
        서버 점검 등으로 예약 시각을 1시간 넘게 지나친 경우에도 뒤늦게 보내지 않고 실패로 처리됩니다
        (한참 지난 &ldquo;내일 회의&rdquo; 안내가 갑자기 나가는 것을 막기 위해서입니다).
      </p>
    </Q>

    <Q q="예전 대화가 검색되지 않습니다.">
      <p>
        검색어 찾기는 <b>현재 화면에 불러온 메시지 안에서만</b> 이루어집니다. 몇 달 전 대화를 찾는다면
        돋보기 버튼을 눌러 검색창을 연 다음, 오른쪽 <UI>달력</UI> 칸에서 그 날짜를 고르세요. 검색어 없이
        날짜만 골라도 그 시점 대화로 바로 이동합니다.
      </p>
      <p>
        이동한 뒤에는 <UI>이전 메시지 불러오기</UI>·<UI>다음 메시지 불러오기</UI>로 앞뒤를 계속 읽을 수
        있고, 오른쪽 아래 <UI>최근 대화로</UI>를 누르면 최신 대화로 돌아옵니다.
      </p>
    </Q>

    <Q q="대화방을 열어뒀는데 상대에게는 안 읽은 것으로 표시됩니다.">
      <p>
        창이 뒤에 있으면(다른 프로그램을 보고 있으면) 읽음으로 처리되지 않습니다. 창을 클릭해 앞으로 가져오는 순간
        읽음 처리됩니다.
      </p>
    </Q>

    <Q q="상대방이 입력 중인지 볼 수 있나요?">
      <p>
        네. 상대가 글을 쓰는 동안 대화창 왼쪽 아래에 &ldquo;○○○님이 입력 중&rdquo; 표시가 나타나고, 입력을
        멈추면 잠시 뒤 사라집니다.
      </p>
    </Q>

    <Q q="@로 특정 사람을 부를 수 있나요?">
      <p>
        네. 입력창에 <UI>@</UI>를 입력하면 멤버 목록이 나타나고, 선택해서 보내면 그 사람에게 알림이 갑니다.
        알림을 꺼둔(뮤트) 대화방이라도 나를 멘션한 메시지는 알림이 옵니다. 자세한 사용법은
        &ldquo;메시지 보내기&rdquo; 도움말을 참고하세요.
      </p>
    </Q>

    <Sub>파일</Sub>

    <Q q="파일이 첨부되지 않습니다.">
      <p>세 가지 제한을 확인하세요.</p>
      <p>
        ① 파일 하나가 <b>{maxFileSizeMB}MB</b>를 넘지 않는지
        <br />② 한 번에 <b>{maxFiles}개</b>를 넘지 않는지
        <br />③ 차단된 확장자(.exe, .bat, .html, .svg 등)가 아닌지
      </p>
      <p>용량이 큰 자료는 사내 공유 폴더를 이용하시는 편이 빠릅니다.</p>
    </Q>

    <Q q="이미지인데 첨부가 안 됩니다.">
      <p>
        <b>.svg 파일은 보안상 차단</b>되어 있습니다. PNG나 JPG로 변환해서 보내주세요.
      </p>
    </Q>

    <Q q="예전에 받은 파일이 열리지 않습니다.">
      <p>
        첨부에는 보관 기간이 있습니다{retentionDays > 0 ? ` (현재 ${retentionDays}일)` : ''}. 기간이 지나면 서버에서
        원본이 삭제되고, 첨부 카드에 <UI>유효기간이 지나 다운로드할 수 없습니다</UI>로 표시됩니다.
      </p>
      <p>
        지워진 파일은 되살릴 수 없습니다. 보낸 사람에게 다시 보내달라고 요청하세요. 남은 기간은 첨부 카드에
        <UI>11월 24일까지</UI>처럼 표시되니, 오래 두고 볼 자료는 미리 내려받아 두시면 됩니다.
      </p>
    </Q>

    <Q q="받은 동영상을 대화창에서 바로 볼 수 있나요?">
      <p>대화창 안에서 재생하는 기능은 없습니다. 파일 카드를 클릭하면 내려받거나 브라우저에서 재생됩니다.</p>
    </Q>

    <Sub>통화</Sub>

    <Q q="통화 버튼이 보이지 않습니다.">
      <p>
        영상 통화는 <b>1:1 대화와 그룹 대화방에서만</b> 쓸 수 있습니다. 공지 채널과 나와의 채팅에는 버튼이 없습니다.
        이미 다른 통화 중일 때도 표시되지 않습니다.
      </p>
    </Q>

    <Q q="통화가 연결되지 않거나 상대 화면이 보이지 않습니다.">
      <p>
        ① 웹으로 접속했다면 주소가 <b>https://</b> 로 시작하는지 확인하세요.
        <br />② 카메라·마이크가 없거나 권한이 없어도 통화는 보기 전용으로 연결됩니다. 내 영상·목소리가 가지 않는다면
        통화 화면의 <b>카메라 없음·마이크 없음</b> 표시와 사용 권한을 확인하세요.
        <br />③ 세 명 이상이라면 참가자들이 <b>비슷한 시점에 받아야</b> 서로 화면이 보입니다. 끊고 다시 걸어보세요.
        <br />④ VPN이나 방화벽이 영상 연결을 막을 수 있습니다. 사내 유선 네트워크에서 시도해 보세요.
      </p>
    </Q>

    <Q q="녹화 파일이 다른 대화방에 올라갔습니다.">
      <p>
        녹화 파일은 <b>녹화를 멈춘 시점에 선택되어 있던 대화방</b>으로 전송됩니다. 다른 방을 보다가 전화를 받은 경우
        생길 수 있습니다. 잘못 올라간 파일은 삭제하고, 통화 상대의 대화방을 선택한 상태에서 다시 녹화하세요.
      </p>
    </Q>

    <Q q="화이트보드에 그린 내용을 저장할 수 있나요?">
      <p>
        저장 기능은 없으며 통화가 끝나면 사라집니다. 남겨야 할 내용은 <UI>화면 캡처</UI>로 찍어 대화방에 올려두세요.
      </p>
    </Q>

    <Sub>계정과 기기</Sub>

    <Q q="PC와 노트북에 동시에 로그인해도 되나요?">
      <p>
        됩니다. 한 곳에서 읽으면 <b>모든 기기에서 안 읽은 표시가 함께 사라지고</b>, 전화도 한 기기에서 받으면 나머지
        기기의 신호음이 멈춥니다. 대화방 고정이나 알림 설정도 모든 기기에 똑같이 적용됩니다.
      </p>
    </Q>

    <Q q="'세션이 만료되었습니다'가 뜹니다.">
      <p>
        보안을 위해 PC에서는 일정 시간이 지나면 자동 로그아웃됩니다. 인트라넷 아이디와 비밀번호로 다시 로그인하세요.
        PC 앱에서 로그인 화면의 <UI>자동 로그인</UI>을 켜 두면 만료되어도 저장된 정보로 조용히 다시 로그인되어 이
        안내가 뜨지 않습니다. 휴대폰·태블릿에서는 앱을 이따금 열기만 하면 로그인이 계속 유지됩니다.
      </p>
    </Q>

    <Q q="'이 채널에 접근할 권한이 없습니다'가 뜹니다.">
      <p>
        대화방에서 나갔거나, 다른 계열사 전용 채널에 접근한 경우입니다. 필요한 방이라면 관리자나 방장에게 초대를
        요청하세요.
      </p>
    </Q>

    <Q q="어두운 테마(다크 모드)로 바꿀 수 있나요?">
      <p>현재 지원하지 않습니다. 글꼴 크기 변경과 알림음 변경도 제공하지 않습니다.</p>
    </Q>

    <Q q="내 상태를 '자리 비움'으로 바꾸고 싶어요.">
      <p>
        PC 앱과 웹에서는 왼쪽 탭 바 맨 아래 <b>내 프로필 사진</b>을 클릭해 <b>자리 비움</b> 또는{' '}
        <b>다른 용무 중</b>을 고를 수 있습니다. 휴대폰에서는 <b>설정 탭 → 내 상태</b>입니다.
      </p>
      <p>
        직접 고른 상태는 앱을 모두 종료하면 풀립니다. 고르지 않아도 <b>5분 동안 PC를 쓰지 않거나 화면을
        잠그면 자동으로 자리 비움</b>이 되고, 다시 움직이면 곧 접속 중으로 돌아옵니다.
      </p>
    </Q>

    <Q q="전체 직원 조직도를 보고 싶어요.">
      <p>
        왼쪽 탭 바의 <b>온라인 탭</b>에서 <b>접속 중인 직원을 회사·부서별로</b> 볼 수 있습니다. 이름이나 부서로
        찾으려면 <b>대화방 개설</b> 창의 검색 칸을 쓰세요. 모바일에서는 화면 아래 <b>온라인 탭</b>이 같은 화면입니다.
      </p>
    </Q>

    <Sub>그래도 해결되지 않으면</Sub>
    <P>
      위 내용으로 해결되지 않는 문제는 정보시스템 담당 부서에 문의해 주세요. 문의하실 때 <b>어떤 화면에서 어떤
      메시지가 표시되었는지</b>와 <b>PC 앱인지 웹인지</b>를 함께 알려주시면 훨씬 빠르게 확인할 수 있습니다.
    </P>
  </>
  );
};
